
import { isArray, mergeOptions } from 'vessel/utils'
import { foreignProps } from 'vessel/utils'

import Panel from '../../panel/src/panel'

const panel = foreignProps(Panel, {
  only: ['title', 'link', 'gutter']
})

export default {
  name: 'VsCard',
  inheritAttrs: false,
  props: {
    ...panel.props,
    mode: {
      type: [String, Object],
      default: 'vertical'
    },
    columns: {
      type: [Array, Object],
      default: () => [4, 8]
    },
    order: {
      type: [Array, Object],
      default: null
    },
    align: {
      type: [String, Object],
      default: 'stretch'
    },
    image: {
      type: [String, Object],
      default: null
    },
    text: {
      type: [String, Object],
      default: null
    },
    background: {
      type: [String, Object],
      default: null
    },
    border: {
      type: [Boolean, String, Object],
      default: null
    },
    shadow: {
      type: [Boolean, String, Object],
      default: null
    },
    radius: {
      type: [Boolean, String, Object],
      default: null
    },
    separator: {
      type: [Boolean, String, Object],
      default: null
    },
    spacing: {
      type: [String, Object],
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  vessel: {
    card: {
      $attrs: 'all',
      width: 'full',
      $shadow: 'shadow',
      $background: 'backgroundColor',
      $border: {
        borderWidth(val) {
          return val == true || val == 'all'
        }
      },
      $radius: {
        borderRadius(val) {
          return val
        },
        overflow(val) {
          return val ? 'hidden' : null
        }
      }
    },
    image: {
      $separator: {
        borderBottomWidth(val) {
          return this.separatorFor(val, 'image', this.vertical)
        },
        borderRightWidth(val) {
          return this.separatorFor(val, 'image', !this.vertical)
        }
      }
    },
    slot: {
      $separator: {
        borderTopWidth(val) {
          return this.separatorFor(val, 'slot', this.vertical)
        },
        borderLeftWidth(val) {
          return this.separatorFor(val, 'slot', !this.vertical)
        }
      }
    },
    content: {
      display: 'flex',
      overflow: 'hidden',
      $align: 'flexItems'
    },
    link: {
      display: 'block',
      width: 'full',
      height: 'full',
      position: 'relative'
    }
  },
  computed: {
    cardComponent() {
      return this.type == 'flex' || this.vertical
        ? 'vs-flex-row'
        : 'vs-grid-row'
    },
    colComponent() {
      return this.type == 'flex' || this.vertical
        ? 'vs-flex-col'
        : 'vs-grid-col'
    },
    orientaton() {
      return this.$screen.match(this.mode)
    },
    vertical() {
      return this.orientaton == 'vertical'
    },
    direction() {
      return this.vertical ? 'col' : 'row'
    },
    hasImage() {
      return this.image || this.$slots.image
    },
    hasSlot() {
      return this.$slots.default
    },
    imageSpan() {
      return this.$vessel.coerce(this.columns, value => value[0])
    },
    mainSpan() {
      return this.$vessel.coerce(this.columns, value => {
        let total = value[1]

        if (!this.hasImage) total += value[0] || 0
        if (!this.hasSlot)  total += value[2] || 0

        return total
      })
    },
    slotSpan() {
      return this.$vessel.coerce(this.columns, value => value[2])
    },
    totalSpan() {
      return this.$vessel.coerce(this.columns, value => {
        return value.reduce((sum, col) => sum + col, 0)
      })
    },
    imageAttrs() {
      return mergeOptions(this.image, href => ({
        source: href,
        fit:    'cover',
        lazy:   true,
        width:  'full',
        height: 'full'
      }))
    },
    panelAttrs() {
      const props  = panel.fetch(this.$props)
      const extend = !this.border && !this.shadow
      const space  = this.spacing
      const border = this.border == 'all'

      let stretch  = !!props.gutter
      let expand   = stretch
      let paddingX = null
      let paddingY = null

      if (this.vertical) {
        stretch  = extend
        paddingY = space
      } else {
        expand   = extend
        paddingX = space
      }

      return {
        ...props,
        border,
        stretch,
        expand,
        paddingX,
        paddingY
      }
    }
  },
  methods: {
    colSpan(area) {
      return this.vertical ? 1 : this[`${area}Span`]
    },
    colOrder(area) {
      return this.$vessel.coerce(this.order, value => {
        return isArray(value) ? value.indexOf(area) + 1 : null
      })
    },
    nodeAttrs(prop, tag) {
      return mergeOptions(prop, text => ({ tag, html: text }))
    },
    separatorFor(val, area, vertical) {
      const border = val == true || val == area
      return vertical && border ? 1 : null
    }
  }
}
